/** tempexp_14728-full-file */
import { Icon20MailOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { memo } from 'react';
import { Avatar } from 'reactApp/ui/Avatar/Avatar';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { NameComponent } from 'reactApp/ui/Name/Name';

import styles from './Destination.css';

interface DestinationProps {
    className?: string;
    destination: string;
    author?: { name?: string; email: string };
    openAttachLetter?: () => void;
    isAttaches?: boolean;
}

export const Destination = memo<DestinationProps>(function Destination({ className, destination, author, openAttachLetter, isAttaches }) {
    return (
        <div className={classNames(styles.root, className)}>
            {author && (
                <div
                    className={classNames(styles.avatar, {
                        [styles.avatarAttaches]: isAttaches,
                    })}
                >
                    <Hint text={author.name || author.email}>
                        <div>
                            <Avatar size={32} email={author.email} name={author.name} />
                        </div>
                    </Hint>
                    {isAttaches && (
                        <Hint text="Перейти к письму">
                            <div className={styles.mailIcon} onClick={openAttachLetter}>
                                <Icon20MailOutline />
                            </div>
                        </Hint>
                    )}
                </div>
            )}
            <NameComponent name={destination} showTooltip truncate />
        </div>
    );
});
